// NATIVE
import { useCallback, useEffect, useRef, useState } from 'react';

// INSTALLED
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  Alert,
  Button,
  Card,
  Divider,
  Grid,
  IconButton,
  Snackbar,
  Tooltip,
  Typography,
} from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

// CUSTOM
import InputField from 'components/formFields/InputField';
import InputNumeric from 'components/formFields/InputNumeric';
import CheckboxField from 'components/formFields/checkBoxField';
import AutocompleteField from 'components/formFields/autocompleteField';
import { IDatosBasicos } from 'commons/interfaces';
import DatePickerField from 'components/formFields/datePickerField';
import { UploadButtonField } from 'components/formFields/uploadButtonField';
import { uploadPdfStore } from 'store/uploaders';
import { SnackAlert } from 'components/SnackAlert';
import { SnackGroupAlerts } from 'components/SnackGroupAlerts';
import { LinearProgressWithLabel } from 'components/LinearProgressWithLabel';
import { PreviewPdfButton } from 'components/PreviewPdfButton';
import { DetailsComponents } from 'components/DetailsComponents';
import { ModalViewPdf } from 'components/modals/viwerPdf/ModalViewPdf';

// import InputNumeric from 'pages/talento-humano/employee/components/stepers/formFields';

export const EditLaboral = (props: any) => {
  const dispatch = useDispatch();

  const formikProps: any = useFormikContext();

  // REDUX
  const { company }: any = useSelector((state: any) => state.company);

  const { cargos_list } = useSelector((state: any) => state.cargos);

  const { payment_method_list, payment_method_list_select }: any = useSelector(
    (state: any) => state.paymentmethod
  );
  const { associated_bank_list, associated_bank_select }: any = useSelector(
    (state: any) => state.associatedbank
  );

  const { payment_frequency_select }: any = useSelector((state: any) => state.paymentfrequency);

  const { employee, employeesContracts } = useSelector((state: any) => state.employee);

  const [urlCertificateBank, setUrlCertificateBank] = useState<any>(null);
  const [showCertificateBank, setShowCertificateBank] = useState(false);

  const [percentage_upload_bk, setPercentageUploadBk] = useState(0);

  const [daysRest, setDaysRest] = useState<any>([]);

  // ALERTS PARA CONFIGURACION FALTANTE
  const [alert_snack_company, setAlertSnackCompany] = useState(false);
  const [alert_snack_cargos, setAlertSnackCargos] = useState(false);

  const {
    formField: {
      // DATOS CLIENTE
      e_type_contract,
      e_salary_base,
      e_transport_subsidy,
      e_payment_method,
      e_frecuency_payment,
      e_associated_bank,
      e_account_number,
      e_certificate_bank,
      e_vacation_acumulate,
      e_bonification_aditional,
      e_date_start_contract,
      e_lunes,
      e_martes,
      e_miercoles,
      e_jueves,
      e_viernes,
      e_sabado,
      e_domingo,
      e_festivo,
      e_dayrest,
    },
  } = props;

  useEffect(() => {
    if (employee && Object.keys(employee).length > 0) {
      setEmployeeData(employee);
    }
  }, [employee]);

  useEffect(() => {
    if (employee && employee.file_certificate_bank_name) {
      setUrlCertificateBank(employee.file_certificate_bank_name);
    }
  }, [employee]);

  const setEmployeeData = (employee: any) => {
    if (formikProps.values.is_initialized_info_laboral) return;
    formikProps.setFieldValue('is_initialized_info_laboral', true);

    // Buscar el contrato por ID en employeesContracts y setear el objeto completo
    if (employee.contract) {
      const contrato = (employeesContracts || []).find(
        (item: any) => item.value === employee.contract.id
      );
      if (contrato) {
        formikProps.setFieldValue('e_type_contract', contrato);
      } else {
        formikProps.setFieldValue('e_type_contract', {
          label: employee.contract.name,
          value: employee.contract.id,
        });
      }
    } else {
      formikProps.setFieldValue('e_type_contract', { label: '', value: '' });
    }

    if (employee.salary_base !== undefined)
      formikProps.setFieldValue('e_salary_base', employee.salary_base);
    if (employee.transport_subsidy !== undefined)
      formikProps.setFieldValue('e_transport_subsidy', employee.transport_subsidy);
    if (
      employee.paymentMethods &&
      employee.paymentMethods.payment_method &&
      employee.paymentMethods.id
    )
      formikProps.setFieldValue('e_payment_method', {
        label: employee.paymentMethods.payment_method,
        value: employee.paymentMethods.id,
      });
    if (
      employee.paymentFrecuencies &&
      employee.paymentFrecuencies.payment_frequency &&
      employee.paymentFrecuencies.id
    )
      formikProps.setFieldValue('e_frecuency_payment', {
        label: employee.paymentFrecuencies.payment_frequency,
        value: employee.paymentFrecuencies.id,
      });

    if (
      employee.associatedBank &&
      employee.associatedBank.associated_bank &&
      employee.associatedBank.id
    )
      formikProps.setFieldValue('e_associated_bank', {
        label: employee.associatedBank.associated_bank,
        value: employee.associatedBank.id,
      });

    if (employee.account_number)
      formikProps.setFieldValue('e_account_number', employee.account_number);

    if (employee.file_certificate_bank_name)
      formikProps.setFieldValue('e_certificate_bank', employee.file_certificate_bank_name);

    if (employee.vacation_acumulate !== undefined)
      formikProps.setFieldValue('e_vacation_acumulate', employee.vacation_acumulate);
    if (employee.bonification_aditional !== undefined)
      formikProps.setFieldValue('e_bonification_aditional', employee.bonification_aditional);
    if (employee.date_start_contract)
      formikProps.setFieldValue('e_date_start_contract', employee.date_start_contract);
    if (employee.lunes !== undefined) formikProps.setFieldValue('e_lunes', employee.lunes);
    if (employee.martes !== undefined) formikProps.setFieldValue('e_martes', employee.martes);
    if (employee.miercoles !== undefined)
      formikProps.setFieldValue('e_miercoles', employee.miercoles);
    if (employee.jueves !== undefined) formikProps.setFieldValue('e_jueves', employee.jueves);
    if (employee.viernes !== undefined) formikProps.setFieldValue('e_viernes', employee.viernes);
    if (employee.sabado !== undefined) formikProps.setFieldValue('e_sabado', employee.sabado);
    if (employee.domingo !== undefined) formikProps.setFieldValue('e_domingo', employee.domingo);
    if (employee.festivo !== undefined) formikProps.setFieldValue('e_festivo', employee.festivo);

    // DOCUMENTS
    if (employee.file_certificate_bank_name)
      formikProps.setFieldValue(
        'e_certificate_banck_name_saved_name',
        employee.file_certificate_bank_name
      );
  };

  // Lista de contratos ahora proviene de employeesContracts en Redux

  const uploadCertificateBank = async ({ target }: any) => {
    const file = target.files[0];
    formikProps.setFieldValue('e_certificate_bank', file);

    const { ok, data } = await dispatch(
      uploadPdfStore('certificate-bank-empleado', file, setPercentageUploadBk)
    );

    if (ok) {
      formikProps.setFieldValue('e_certificate_banck_name_saved_name', data.pdfName);
    }
  };

  // useEffect(() => {
  //   configMission();
  // }, []);

  // useEffect(() => {

  //    ( payment_frequency_select.length <=  ) ? :
  // }, [payment_frequency_select])

  // const configMission = () => {

  //   if ( Object.keys(company).length === 0 && company.constructor === Object ) {
  //        setAlertSnackCompany(true);
  //   } // END IF

  //   if ( Object.keys(cargos_list).length === 0  ) {
  //        setAlertSnackCargos(true);
  //   } // END IF

  // }

  const oneDayRest = (day: string) => {
    const found = daysRest.find((element: any) => element == day);

    if (found) {
      const elements = daysRest.filter(function (item: any) {
        return item !== day;
      });

      setDaysRest(elements);
      formikProps.setFieldValue('dayrest', day);
    } else {
      setDaysRest([...daysRest, day]);
      formikProps.setFieldValue('', day);
    }
  };

  const openCertBank = () => {
    setShowCertificateBank(!showCertificateBank);
  };

  return (
    <div>
      <SnackAlert
        open={alert_snack_cargos}
        autohidden={false}
        onclick={setAlertSnackCargos}
        text={'Aun no has creado los cargos'}
        severity={'warning'}
      />

      {showCertificateBank && (
        <ModalViewPdf
          open={showCertificateBank}
          onClose={setShowCertificateBank}
          pdfUrl={urlCertificateBank}
        />
      )}

      <Grid container spacing={2}>
        <Grid size={3}>
          {employeesContracts && employeesContracts.length > 0 ? (
            <AutocompleteField
              options={employeesContracts}
              name={e_type_contract.name}
              label={e_type_contract.label}
              required={true}
              element={e_type_contract.name}
            />
          ) : (
            <InputField
              disabled
              error
              name={'N/A'}
              label={'Debes crear los contratos*'}
              variant="outlined"
              fullWidth
            />
          )}
        </Grid>
        <Grid size={3}>
          <InputNumeric
            name={e_salary_base.name}
            label={e_salary_base.label}
            required={true}
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid size={3}>
          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
            <CheckboxField
              name={e_transport_subsidy.name}
              label={e_transport_subsidy.label}
              required={true}
            />
          </div>
        </Grid>
        <Grid size={3}>
          {payment_method_list_select && payment_method_list_select.length > 0 ? (
            <AutocompleteField
              options={payment_method_list_select}
              name={e_payment_method.name}
              label={e_payment_method.label}
              required={true}
            />
          ) : (
            <InputField
              disabled
              error
              name={'N/A'}
              label={'Debes crear la frecuencia de pago*'}
              variant="outlined"
              fullWidth
            />
          )}
        </Grid>
      </Grid>
      {/* END GRID  */}

      <Grid container spacing={2} style={{ marginTop: 15 }}>
        <Grid size={3}>
          {payment_frequency_select && payment_frequency_select.length > 0 ? (
            <AutocompleteField
              options={payment_frequency_select}
              name={e_frecuency_payment.name}
              label={e_frecuency_payment.label}
              required={true}
            />
          ) : (
            <InputField
              disabled
              error
              name={'N/A'}
              label={'Debes crear la frecuencia de pago*'}
              variant="outlined"
              fullWidth
            />
          )}
        </Grid>
        <Grid size={3}>
          {associated_bank_select && associated_bank_select.length > 0 ? (
            <AutocompleteField
              options={associated_bank_select}
              name={e_associated_bank.name}
              label={e_associated_bank.label}
              required={true}
            />
          ) : (
            <InputField
              disabled
              error
              name={'N/A'}
              label={'Debes crear los bancos*'}
              variant="outlined"
              fullWidth
            />
          )}
        </Grid>
        <Grid size={3}>
          <InputField
            name={e_account_number.name}
            label={e_account_number.label}
            required={true}
            variant="outlined"
            fullWidth
          />
        </Grid>

        {/* file_certificate_bank_name */}
        <Grid size={3}>
          <div onClick={openCertBank}>
            <DetailsComponents />
          </div>
          <UploadButtonField
            accept={'application/pdf'}
            name={e_certificate_bank.name}
            label={e_certificate_bank.label}
            required={
              !(
                formikProps.values.e_certificate_bank ||
                (formikProps.values.e_certificate_banck_name_saved_name &&
                  !formikProps.values.e_certificate_banck_name_saved_name.includes('dummy')) ||
                (formikProps.values.certificate_banck_name_saved_name &&
                  !formikProps.values.certificate_banck_name_saved_name.includes('dummy'))
              )
            }
            text={'Certificado bancario'}
            onChange={uploadCertificateBank}
            style={{ marginTop: 10, width: '100%' }}
          />
          {formikProps.values.e_certificate_bank ||
          formikProps.values.e_certificate_banck_name_saved_name ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1, height: '70%' }}>
              <LinearProgressWithLabel
                percentage={
                  formikProps.values.e_certificate_banck_name_saved_name
                    ? 100
                    : percentage_upload_bk
                }
                label={formikProps.values.e_certificate_bank?.name || 'Certificado bancario'}
                hasIcon={true}
              />
              {!formikProps.values.e_certificate_banck_name_saved_name?.includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_certificate_banck_name_saved_name}
                  typeUrl="certificate-bank-empleado"
                  onOpenPdf={props.onOpenPdf}
                  label="Previsualizar Certificado"
                />
              )}
            </Card>
          ) : (
            ''
          )}
        </Grid>
      </Grid>
      {/* END GRID  */}

      <Grid container spacing={2} style={{ marginTop: 15 }}>
        <Grid size={3}>
          <DatePickerField
            label={e_date_start_contract.label}
            required={true}
            name={e_date_start_contract.name}
          />
        </Grid>
        <Grid size={3}>
          <InputNumeric
            name={e_vacation_acumulate.name}
            label={e_vacation_acumulate.label}
            required={true}
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid size={3}>
          <InputNumeric
            name={e_bonification_aditional.name}
            label={e_bonification_aditional.label}
            required={true}
            variant="outlined"
            fullWidth
          />
        </Grid>
      </Grid>
      {/* END GRID  */}

      <Divider style={{ marginTop: 25 }} />
      {daysRest.length <= 0 && (
        <Typography variant="h6" sx={{ fontWeight: 'bold', marginTop: 10, color: 'red' }}>
          Debes seleccionar al menos un día de descanso*
        </Typography>
      )}
      <Typography variant="h6" sx={{ fontWeight: 'bold', marginTop: 10 }}>
        Días de descanso
      </Typography>

      <Grid container spacing={2}>
        <Grid size={2}>
          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
            <CheckboxField
              onChange={() => oneDayRest(e_lunes.name)}
              name={e_lunes.name}
              label={e_lunes.label}
              required={true}
            />
          </div>
        </Grid>
        <Grid size={2}>
          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
            <CheckboxField
              onChange={() => oneDayRest(e_martes.name)}
              name={e_martes.name}
              label={e_martes.label}
              required={true}
            />
          </div>
        </Grid>
        <Grid size={2}>
          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
            <CheckboxField
              onChange={() => oneDayRest(e_miercoles.name)}
              name={e_miercoles.name}
              label={e_miercoles.label}
              required={true}
            />
          </div>
        </Grid>
        <Grid size={2}>
          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
            <CheckboxField
              onChange={() => oneDayRest(e_jueves.name)}
              name={e_jueves.name}
              label={e_jueves.label}
              required={true}
            />
          </div>
        </Grid>
        <Grid size={2}>
          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
            <CheckboxField
              onChange={() => oneDayRest(e_viernes.name)}
              name={e_viernes.name}
              label={e_viernes.label}
              required={true}
            />
          </div>
        </Grid>
        <Grid size={2}>
          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
            <CheckboxField
              onChange={() => oneDayRest(e_sabado.name)}
              name={e_sabado.name}
              label={e_sabado.label}
              required={true}
            />
          </div>
        </Grid>
        <Grid size={2}>
          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
            <CheckboxField
              onChange={() => oneDayRest(e_domingo.name)}
              name={e_domingo.name}
              label={e_domingo.label}
              required={true}
            />
          </div>
        </Grid>
        <Grid size={2}>
          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
            <CheckboxField
              onChange={() => oneDayRest(e_festivo.name)}
              name={e_festivo.name}
              label={e_festivo.label}
              required={true}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
